module.exports = __webpack_public_path__ + "images/emoji/heart_eyes_cat.164654c997965f38189d.png";